// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iojie","content":"styles_content__e1dpu"};